<div id="mdl-confirmacao" class="mdl-confirmacao">
  <div class="mdl-confirmacao__icone" [class.mdl-confirmacao__icone--atencao]="icone === 'warning'" aria-hidden="true">
    {{ icone === 'warning' ? '!' : '?' }}
  </div>

  <h4 class="modal-title" id="ttl-mdl-confirmacao">{{ titulo }}</h4>

  <div class="br-modal-body">@for (parte of partesMensagem; track $index) {<span [class.mdl-confirmacao__destaque]="parte.destaque">{{ parte.texto }}</span>}</div>

  <div class="br-modal-footer justify-content-center">
    <br-button id="btn-mdl-confirmacao-confirmar" type="button" emphasis="primary"
      (click)="confirmar()" (keyup)="confirmar()" (keydown)="confirmar()">
      {{ confirmLabel }}
    </br-button>
    @if (cancelLabel) {
      <br-button id="btn-mdl-confirmacao-cancelar" type="button" emphasis="secondary"
        (click)="activeModal.dismiss()" (keyup)="activeModal.dismiss()" (keydown)="activeModal.dismiss()">
        {{ cancelLabel }}
      </br-button>
    }
  </div>
</div>
